import { CalendarClock, Mail } from "lucide-react";
import { useAuthContext } from "@/contexts/AuthContext";
import { useI18n } from "@/contexts/I18nContext";
import { trpc } from "@/lib/trpc";

const DAY_MS = 24 * 60 * 60 * 1000;

export function BillingReminder() {
  const { user } = useAuthContext();
  const { ui, formatDate } = useI18n();
  const accessQuery = trpc.admin.getMyAccessStatus.useQuery(undefined, {
    enabled: !!user && user.role !== "admin",
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const dueAt = accessQuery.data?.nextBillingDueAt;
  if (!dueAt) return null;

  const daysUntilDue = Math.ceil((dueAt - Date.now()) / DAY_MS);
  // Aviso discreto nos cinco dias antes do vencimento e enquanto estiver em atraso.
  if (daysUntilDue > 5) return null;

  let message: string;
  if (daysUntilDue > 0) {
    message = ui.billing.dueSoon.replace("{date}", formatDate(new Date(dueAt), { day: "2-digit", month: "long", year: "numeric" }));
  } else if (daysUntilDue === 0) {
    message = ui.billing.dueToday;
  } else {
    message = ui.billing.overdue.replace("{days}", String(Math.abs(daysUntilDue)));
  }

  return (
    <div className="mx-4 mt-4 lg:mx-6 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-amber-950 dark:border-amber-900/60 dark:bg-amber-950/30 dark:text-amber-100" role="status">
      <div className="flex items-start gap-3">
        <CalendarClock className="mt-0.5 h-5 w-5 shrink-0 text-amber-700 dark:text-amber-300" />
        <div className="min-w-0 flex-1">
          <p className="text-sm leading-relaxed">{message}</p>
          <a
            href="mailto:contato@tuticonsultoria.com.br?subject=Bolso%20-%20mensalidade"
            className="mt-2 inline-flex items-center gap-1.5 text-sm font-semibold underline underline-offset-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-700 rounded"
          >
            <Mail className="h-3.5 w-3.5" />
            {ui.billing.contact}
          </a>
        </div>
      </div>
    </div>
  );
}
